// extracted by mini-css-extract-plugin
module.exports = {"cameraDetailsColumn":"CameraDetails_cameraDetailsColumn__9MrTo","cameraDetailsColumns":"CameraDetails_cameraDetailsColumns__lMRii"};